import styled from "styled-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { CenteredFlexRow, FlexColumn, FlexRow, LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexColumn)`
    width: 100%;
    height: 427px;
`;

export const InvitationItem = styled(LeftFlexRow)`
    padding: 14px 0;
    border-bottom: 1px solid ${colorsPalettes.carbon[25]};
`;

export const InnerContainer = styled(FlexRow)`
    width: 508px;
    align-items: center;
    justify-content: space-between;
`;

export const Text = styled.span`
    ${setFontVariant("listItem1", colorsPalettes.carbon[400])};
`;

export const EmailText = styled(Text)`
    max-width: 400px;
    overflow: hidden;
`;

export const InvitationBadge = styled(CenteredFlexRow)`
    height: 32px;
    width: 32px;
    ${setFontVariant("listSectionTitle", colorsPalettes.carbon[0])};
    background: ${colorsPalettes.midnight[400]};
    border-radius: 50%;
    margin-right: 10px;
`;

export const InvitationStatus = styled(CenteredFlexRow)<{ isActive: boolean }>`
    border-radius: 40px;
    background-color: ${({ isActive }) => (isActive ? colorsPalettes.green[100] : colorsPalettes.carbon[50])};
    height: 24px;
    padding: 4px 12px;
    ${setFontVariant("chip1", colorsPalettes.carbon[400])};
    margin-left: auto;
`;
